@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-input
      [formControl]="control"
      [maxLength]="attribute.max || null"
      [minLength]="attribute.min || null"
      [invalidText]="createInvalidText(control)"
      class="w-100"
      id="{{ attribute.name }}"
      />
    </div>
  }
  <ix-spinner [class.d-none]="!isLoading"></ix-spinner>
